import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import UserProductGroupErrorResponse from '~/Api/User/ProductGroup/UserProductGroupErrorResponse';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import Meta from './Meta';

export default function addProductsToUserGroup(
	client: ApiClient,
	userId: string,
	groupId: string,
	items: { id: string; packageSizeForSingleUnit: number | null }[],
	meta: Meta | null
): Promise<void> {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/products');
	const body = {
		items,
		meta: meta !== null ? mapMeta(meta) : null,
	};

	return client
		.fetch(url.expand({ userId, groupId }), {
			method: 'POST',
			body: JSON.stringify(body),
		})
		.catch((response) => ApiClientErrorResponse.wrapError(response, UserProductGroupErrorResponse));
}

function mapMeta(meta: Meta): { searchFilters: { [key: string]: string | null } } {
	return {
		searchFilters: meta.searchFilters.reduce((result: { [key: string]: string | null }, filterParameter) => {
			const parsedValue = filterParameter.parseDateValue();
			if (filterParameter.name === 'newerThan' && parsedValue) {
				return {
					...result,
					[filterParameter.name]: formatApiDate(parsedValue),
				};
			} else if (filterParameter.value instanceof Array) {
				return {
					...result,
					[filterParameter.name]: filterParameter.value.join(','),
				};
			} else if (filterParameter.value !== '') {
				return {
					...result,
					[filterParameter.name]: filterParameter.value,
				};
			}

			return result;
		}, {}),
	};
}
